import { InvalidPermissions } from '../invalid-permissions/InvalidPermisions';
import { Loading } from '../loading/Loading';
import TopNavBar from '../top-nav-bar/TopNavBar';
import { AppLayoutProps } from './AppLayout';

export function AppLayoutRenderHelper(props: AppLayoutProps) {
  if (props.status === 'success') {
    if (props.permissions && props.user) {
      return (
        <>
          <TopNavBar {...props} />
          {props.children}
        </>
      );
    } else if (!props.user || !props.permissions) {
      return (
        <>
          <TopNavBar {...props} />
          <InvalidPermissions />
        </>
      );
    } else {
      return <Loading showIcon />;
    }
  }

  if (props.status === 'loading') {
    return <Loading showIcon />;
  }

  return (
    <>
      <TopNavBar {...props} hideTabs />
      <Loading showIcon />
    </>
  );
}
